function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IsliderArrowLeft = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0825 17.8725L10.4125 12.2925L15.9925 6.7025C16.3825 6.3125 16.3825 5.6825 15.9925 5.2925C15.6025 4.9025 14.9725 4.9025 14.5825 5.2925L8.2925 11.5925C7.9025 11.9825 7.9025 12.6125 8.2925 13.0025L14.6725 19.2925C15.0625 19.6825 15.6925 19.6825 16.0825 19.2925C16.4625 18.9025 16.4725 18.2625 16.0825 17.8725Z",
    fill: "#495057"
  }));
});